module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "firstInSection"
  }, [_vm._v("On one side lay the Ocean, and on one"), _c('br'), _vm._v("\nLay a great water, and the moon was full.")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('b', [_vm._v("Alfred, Lord Tennyson")]), _vm._v(", "), _c('em', [_vm._v("Idylls of the King")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cbff5012","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter2.vue
// module id = 69
// module chunks = 0